<div class="modal-header">
  <h3>Delete Confirmation</h3>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="closeDialog()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">Are you sure you want to delete this item?</div>
<div class="modal-footer">
  <button type="button" class="btn app-btn-green" (click)="closeDialog()">
    Cancel
  </button>
  <button type="button" class="btn btn-danger" (click)="deleteUser()">
    Delete
  </button>
</div>
